<template>
    <div class="content">
<!--        <div class="popup_content" v-html="popup.p_content"></div>-->
        <div class="content detail">
            <div class="detailheader">
                <div class="detailtitle">{{popup.p_title}}</div>
                <p class="detail_p">{{returnDate(popup.created_at)}}</p>
            </div>
            <div class="detailbody">
                <div class="popup_content" v-html="popup.p_content"></div>

<!--                <div class="dbody_photo" :style="`background-image: url(${returnPopupImage(popup)})`"></div>-->



            </div>
            <button class="detail_btn" @click="backEvent()">목록</button>
        </div>
    </div>
</template>

<script>
    import imageOption from "@/mixins/imageOption";
    export default {
        name: "PopupDetailComponent",
        mixins: [imageOption],
        components: {},
        props: {
            popupKey: {},
        },
        data() {
            return {
                popup: {},
            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {
            this.getPopup()
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            getPopup(){
                let params = {
                    fi: 1,
                    ip: 0,
                    id: this.popupKey,
                    isdi: 1,
                }
                this.$api.$popup.getPopup(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type == 1) {
                        this.popup = res.List[0];
                    }
                })
            },
            backEvent(){
                this.$router.go(-1);
            },
            returnPopupImage(pop) {
                return pop.hasOwnProperty('File') ? `${pop.File[0].org_url}?${this.setImageOptions(579, 413, 'png')}` : ''
            },
            returnDate(date = null) {
                if (!date) {
                    return '';
                }
                return this.$moment(date).format('YYYY-MM-DD HH:mm')
            },
        },
        watch: {},
    }
</script>

<style lang="scss">
.popup_content{
    *{
        max-width: 1100px;
    }
}
</style>